import { Box, Chip, useTheme } from '@material-ui/core';
import { FunctionField, useTranslate } from 'react-admin';
import React from 'react';
import { CAMPAIGN_STATUS } from '../../../constant/campaign';

const CampaignStatus = (props) => {
  const t = useTranslate();
  const theme = useTheme();
  return (
    <FunctionField
      source="status"
      render={(record) => (
        <Box
          component={Chip}
          sx={{
            "&[class*='Chip']": {
              padding: '3px 12px',
              backgroundColor: {
                [CAMPAIGN_STATUS.ACTIVE]: theme.palette.success.main,
                [CAMPAIGN_STATUS.EXPIRED]: theme.palette.warning.light,
                [CAMPAIGN_STATUS.CANCELED]: theme.palette.grey[400],
              }[record.status],
              color: 'white',
              '& span': {
                padding: '0 !important', // To override default styles
              },
            },
          }}
          label={t(`resources.campaign.status.${record.status}`)}
        />
      )}
      {...props}
    />
  );
};

export default CampaignStatus;
